require('./contractEasyLoanTypeCStep2.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// Commons components
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ CC Components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
// @Components
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');

// @constants
const {
    VIEWER_HEIGHT_INE_PDF,
    INE_DOCUMENT_NAME
} = require('../../../../loansConstants/index');

//@utilities
const download = require('downloadjs');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const {
    analyticsId,
    recordEasyLoanCINEScroll,
    recordEasyLoanCINECheckbox,
    recordEasyLoanCINEPrint,
    recordEasyLoanCINEDownload,
    recordEasyLoanCUpdateEmail,
    recordEasyLoanCSendEmail,
} = require( '../analytics/contractEasyLoanTypeC.tracking' );


class ContractEasyLoanTypeCStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { agreeCheckModal: false, confirmed: false };
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleAgreeCheckModal = this.handleAgreeCheckModal.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
    }

    componentDidMount() {
        const { getFindOutLoanInitINEContractDocuments, immContractEasyLoanInit, getPropositionNumber } = this.props;
        const operationProcessId = immContractEasyLoanInit.get('operationProcessId');
        operationProcessId === (null || undefined) && getFindOutLoanInitINEContractDocuments('precontractual')
        !operationProcessId && getPropositionNumber()
    }

    handleDocumentReaded() {
        const { checkReadDocument } = this.props;
        this.setState({ isPdfReeded: true });
        checkReadDocument()
    }

    handleAgreeCheckModal(event) {
        recordEasyLoanCINECheckbox(event.target.checked);
        this.props.toggleTypecIneAgreeCheckbox()
    }

    handleOnDownloadDocument() {
        const { immContractEasyLoanInit } = this.props;
        let documentName = '';
        let document;
        document = immContractEasyLoanInit.get('fileEasyLoanTypecIneDocument');
        documentName = INE_DOCUMENT_NAME;
        recordEasyLoanCINEDownload(analyticsId.TAG_DOWNLOAD);
        download(document, documentName, 'application/pdf');
    }

    handleOnPrintDocument() {
        const { immContractEasyLoanInit } = this.props;
        const document = immContractEasyLoanInit.get('fileEasyLoanTypecIneDocument');
        if (document) {
            recordEasyLoanCINEPrint();
            isPrintOfficeMode() && this.props.printIneDocumentStep2()
            openBase64pdfInPrintWindow(document);
        }
    }
    buildCheckbox() {
        const {
            validate,
            immContractEasyLoan
        } = this.props;
        const errorLoading = immContractEasyLoan.get('errorEasyLoanTypecIneDocument') || !this.state.isPdfReeded;
        const agreeIneCheckbox = immContractEasyLoan.get('agreeTypeCINECheckbox');
        const isEasyLoanEmailSent = immContractEasyLoan.get('isEasyLoanEmailSent');
        const errorState = (validate && !agreeIneCheckbox);
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const checkbox = (
            <div>
                <OKCheckbox
                    extraClass="contract-loan-pdf-viewer__checkbox"
                    errorMessage={errorMessage}
                    errorState={errorState}
                    disabled={__CONTACT_CENTER__ ? !isEasyLoanEmailSent : false}
                    idName="contract-loan-pdf-viewer-checkbox"
                    label={__CONTACT_CENTER__ ? <FormattedText value={"contractEasyLoanTypeCStepTwo-newCheckboxCCText"} /> : <FormattedText value={'contractEasyLoanTypeCStepTwo-checkboxText'} />}
                    onChange={this.handleAgreeCheckModal}
                    value={agreeIneCheckbox}
                />
            </div>
        )

        return __CONTACT_CENTER__ || !errorLoading ? checkbox : null;
    }
    buildViewer() {
        const { immContractEasyLoan, immContractEasyLoanInit, scale, getINEDocument } = this.props;
        const fileINEDocument = immContractEasyLoanInit.get('fileEasyLoanTypecIneDocument');
        const errorINEDocument = immContractEasyLoan.get('errorEasyLoanTypecIneDocument');
        const isFetchingINEDocument = immContractEasyLoan.get('isFetchingINEDocument');
        const fetchingProposition = immContractEasyLoan.get('fetchingProposition');

        if (isFetchingINEDocument || fetchingProposition) {
            return <LoadingSection />;
        }

        return (
            <OKPdfViewer
                title={formatText('contractEasyLoanTypeCStepTwo-ineTitleText')}
                onDownload={this.handleOnDownloadDocument}
                onPrint={this.handleOnPrintDocument}
                pdfFile={fileINEDocument}
                displayScrollButton
                scale={scale}
                infiniteScroll={false}
                failedLoadingPdf={errorINEDocument}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError getDocuments={getINEDocument} />
                }}
                viewerHeight={VIEWER_HEIGHT_INE_PDF}
                onDocumentReaded={this.handleDocumentReaded}
                scrollButtonAction={recordEasyLoanCINEScroll}
            />
        )
    }

    buildPreContractualMailInfo() {
        const {
            immProfile,
            immContractEasyLoan,
            preContractualMail,
            requestProfile,
            sendMail,
            sendEasyLoanSimpleEmail
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const refreshEmailError = immProfile.get('error');


        return (
            <PreContractualMailInfo
                email={clientEmail}
                preContractualMail={preContractualMail}
                profileError={refreshEmailError}
                requestProfile={requestProfile}
                sendEmail={sendMail}
                showLegalText={false}
                legalInfoText={false}
                sendSimpleEmail={sendEasyLoanSimpleEmail}
                mainFlag={'EASY_LOAN_TYPEC'}
                contractObj={immContractEasyLoan}
                tagRefreshMailEvent={recordEasyLoanCUpdateEmail}
                tagSendEmailEvent={recordEasyLoanCSendEmail}
            />
        );
    }

    blockInfoView() {
        const { immProfile } = this.props;
        const name = " " + immProfile.get("nombreCompleto");
        return (
            <div className="contract-easy-loan-typec-document-step__blockView">
                <div className="contract-easy-loan-typec-document-step__subtitle">
                    <FormattedText value="contractEasyLoanTypeCStepTwo-blockHeadingTitle" />
                </div>
                <BlockInfo>
                    <FormattedText value={'contractEasyLoanTypeCStepTwo-blockCCTitleStart'} />
                    {name}
                    <br />
                    <FormattedText value={'contractEasyLoanTypeCStepTwo-blockCCTitle'} />
                </BlockInfo>
            </div>
        );
    }

    officeBlockInfoView() {
        return (
            <div className="contract-easy-loan-typec-document-step__blockView">
                <BlockInfo>
                    <FormattedText value={'contractEasyLoanTypeCStepTwo-blockTitle'} />
                </BlockInfo>
            </div>
        )

    }

    buildLegalInfoText() {
        const information = formatText('contractEasyLoanTypeCStepTwo-legalInfoText');
        return (
            <div className="contract-easy-loan-typec-document-step__information">
                <i className="icon-informacion"></i>
                {information}
            </div>
        );
    }

    render() {
        const checkbox = !isPrintOfficeMode() && this.buildCheckbox();
        let viewer = this.buildViewer()
        const officeBlockInfoView = isPrintOfficeMode() && this.officeBlockInfoView();
        let blockInfo, legalInfoText;

        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            blockInfo = this.blockInfoView();
            viewer = this.buildPreContractualMailInfo();
            legalInfoText = this.buildLegalInfoText();
        }

        return (
            <section className="contract-easy-loan-typec-document-step">
                <div className="contract-easy-loan-typec-document-step__title">
                    <FormattedText value="contractEasyLoanTypeCStepTwo-ineTitleText" />
                </div>
                <div className="contract-easy-loan-typec-document-step__informative-text">
                    <FormattedText value="contractEasyLoanTypeCStepTwo-ineTitleSubText" />
                </div>
                {blockInfo}
                {officeBlockInfoView}
                {viewer}
                {checkbox}
                {legalInfoText}
            </section>
        );
    }
}

ContractEasyLoanTypeCStep2.propTypes = {
    beforeStep: PropTypes.number.isRequired,
    errorAsnef: PropTypes.bool,
    immContractEasyLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    toggleTypecIneAgreeCheckbox: PropTypes.func.isRequired,
    validate: PropTypes.bool,
    scale: PropTypes.number,
    immAccounts: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    printIneDocumentStep2: PropTypes.func.isRequired,
    sendEasyLoanSimpleEmail: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    sendMail: PropTypes.func.isRequired,
    immContractEasyLoanInit: PropTypes.object,
    checkReadDocument: PropTypes.func.isRequired,
};

ContractEasyLoanTypeCStep2.defaultProps = {
    scale: 1,
};

module.exports = ContractEasyLoanTypeCStep2;